export const alertsData = {
    total_alerts: 123,
    years: [
        {
            name: '1',
            total_count: 12,
            classes: [
                { name: 'Class 1-A', count: 5, id: '' },
                { name: 'Class 1-B', count: 6, id: '' },
                { name: 'Class 1-C', count: 1, id: '' },
            ],
        },
        {
            name: '2',
            total_count: 27,
            classes: [
                { name: 'Class 2-A', count: 9, id: '' },
                { name: 'Class 2-B', count: 9, id: '' },
                { name: 'Class 2-C', count: 9, id: '' },
            ],
        },
        {
            name: '3',
            total_count: 58,
            classes: [
                { name: 'Class 3-A', count: 15, id: '' },
                { name: 'Class 3-B', count: 15, id: '' },
                { name: 'Class 3-C', count: 14, id: '' },
                { name: 'Class 3-D', count: 14, id: '' },
            ],
        },
        {
            name: '4',
            total_count: 26,
            classes: [
                { name: 'Class 4-A', count: 9, id: '' },
                { name: 'Class 4-B', count: 9, id: '' },
                { name: 'Class 4-C', count: 8, id: '' },
            ],
        },
    ],
}
